function base64UrlEncode(bytes) {
    let binary = "";
    for (const byte of bytes)
        binary += String.fromCharCode(byte);
    return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
export function generateCodeVerifier() {
    return base64UrlEncode(crypto.getRandomValues(new Uint8Array(48)));
}
export async function deriveCodeChallenge(codeVerifier) {
    const digest = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(codeVerifier));
    return base64UrlEncode(new Uint8Array(digest));
}
